import React from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { RootState, storeActions } from '../../../store'
import { Mode } from '../../../models/enums'
import { HistoryButton, LanguageButton, TutorialButton } from '.'
import { Toggle } from '../../Utils'
import DisplaySubViews from '../ViewsDisplay/DisplaySubViews'

interface ParametersProps {
  handleBack?: () => void
}

const Parameters = ({ handleBack }: ParametersProps): JSX.Element => {
  const dispatch = useDispatch()
  const translation = useSelector((state: RootState) => state.localeReducer.currentTranslations)
  const mode = useSelector((state: RootState) => state.speechReducer.mode)
  const displaySubtitles = useSelector((state: RootState) => state.retorikReducer.displaySubtitles)
  const disableHistory = useSelector((state: RootState) => state.retorikReducer.configuration.disableHistory)
  const disableSubtitles = useSelector((state: RootState) => state.retorikReducer.configuration.disableSubtitles)
  const muted = useSelector((state: RootState) => state.speechReducer.muted)
  const disableSound = useSelector((state: RootState) => state.speechReducer.disableSound)
  const isMobile = useSelector((state: RootState) => state.viewReducer.isMobile)

  const handleSoundChange = (val: boolean) => {
    dispatch(storeActions.speech.setMuted(!val))
  }

  return (
    <React.Fragment>
      {/* Sound */}
      {!disableSound && <Toggle className='rf-py-3 large:rf-py-0' title={translation.common.sound} handleChange={handleSoundChange} defaultChecked={!muted} />}

      {/* Separating line only in mobile / widget modes */}
      {isMobile && <div className='rf-h-0 rf-w-full rf-border-t rf-border-t-menuBorder' />}

      {/* Subtitle */}
      {mode !== Mode.text && !disableSubtitles && (
        <Toggle
          className='rf-py-3 large:rf-py-0'
          title={translation.common.subtitle}
          handleChange={(on: boolean) => dispatch(storeActions.retorik.setDisplaySubtitles(on))}
          defaultChecked={displaySubtitles}
        />
      )}

      {/* Languages / Tutorial / History */}
      {isMobile && (
        <React.Fragment>
          <LanguageButton />
          <TutorialButton handleBack={handleBack} />
          {!disableHistory && <HistoryButton handleBack={handleBack} />}
          <DisplaySubViews handleClick={handleBack} />
        </React.Fragment>
      )}
    </React.Fragment>
  )
}

export default Parameters
